import React, { useEffect, useMemo, useState } from 'react'
import ListContainer from '../../../list'
import { FormActionButtons, Switch } from '../../../../components'
import { Button, Link, makeStyles } from '@material-ui/core';
import { getI18n, getI18nFormattedMessage } from '../../../../utils/intl';
import { useParams } from 'react-router';
import { connect, useDispatch } from 'react-redux';
import {
  GRID_ROWS_PER_PAGE_DEFAULT_OPTION,
  UPDATE_ORGANIZATIONS_FOR_API_PLANS_SUCCESS,
} from '../../../../constants';
import { FilterByName, HeaderActionButtons } from '../controls';
import styles from "../Apis/styles";
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import {
  fetchOrganizationsForApiPlans,
  updateOrganizationsForApiPlans,
} from '../../../../actions/apiPlans';
import {
  getApiPlansLoading, getOrganizationsResultsForApiPlans,
  getOrganizationsTotalElementsForApiPlans, getOrganizationsTotalPagesForApiPlans,
  getOrgsUpdateForApiPlans,
} from '../../../../reducers/apiPlans';
import { cloneDeep, every, map } from 'lodash';
import { compareArrays, ORGANIZATIONS_ADD_ACCESS, ORGANIZATIONS_REMOVE_ACCESS } from '../utils';
import { compose } from 'recompose';

export const Organizations = (props) => {
  const {
    apiPlanUuid,
    setCurrentTab,
    isLoading,
    orgsResultsForApiPlans,
    orgsTotalElementsForApiPlans,
    orgsTotalPagesForApiPlans,
    isUpdateOrgsForApiPlansSuccess,
    setAlertMessages,
    setCurrentTabDirty,
  } = props

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(GRID_ROWS_PER_PAGE_DEFAULT_OPTION);
  const [filterByOrgName, setFilterByOrgName] = useState('');
  const [appliedFilterByOrgName, setAppliedFilterByOrgName] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [changeMode, setChangeMode] = useState(ORGANIZATIONS_REMOVE_ACCESS);
  const [currentOrgRows, setCurrentOrgRows] = useState([]);
  const [assignedOrgs, setAssignedOrgs] = useState([]);
  const [unAssignedOrgs, setUnAssignedOrgs] = useState([]);
  const [payload, setPayload] = useState({
    page: page,
    size: rowsPerPage,
    orgName: filterByOrgName,
    apiPlanOrgAccessStatus: "ASSIGNED",
  })

  const params = useParams();
  const dispatch = useDispatch();
  const currentTab = params?.tabName;
  const isCurrentTab = currentTab === 'organizations';

  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const isOrgsRemoveAccess = changeMode === ORGANIZATIONS_REMOVE_ACCESS;
  const isOrgsAddAccess = changeMode === ORGANIZATIONS_ADD_ACCESS;

  const assignedOrgsFromApi = isOrgsRemoveAccess && orgsResultsForApiPlans &&
    orgsResultsForApiPlans?.map(api => api?.organizationUuid);

  useEffect(() => {
    setAssignedOrgs(assignedOrgsFromApi || []);
    setUnAssignedOrgs(assignedOrgsFromApi || []);
  }, [orgsResultsForApiPlans]);


  useEffect(() => {
    if (isCurrentTab) {
      setAppliedFilterByOrgName('');
      setFilterByOrgName('');
      setPage(0);
      setCurrentTab('add-api-plans-organizations-tab');
      setSelectedRows([]);
      setCurrentTabDirty(false);
      setChangeMode(ORGANIZATIONS_REMOVE_ACCESS)
      setPayload({
        ...payload,
        apiPlanOrgAccessStatus: "ASSIGNED",
      })
    }
  }, [isCurrentTab])

  const onAccessToggle = (val, uuid) => {
    setAssignedOrgs(prevAssignedApis =>
      val
        ? [...prevAssignedApis, uuid]
        : prevAssignedApis.filter(orgUuid => orgUuid !== uuid),
    );
  };

  const getListColumns = ({ getI18nFormattedMessage }) => [{
    id: 'organization',
    label: getI18nFormattedMessage("label.organization"),
    minWidth: 200,
    format: (item) => {
      return (
        (<Link underline="none" className={classes.link} href={`/admin/console/organizations/details/${item.organizationUuid}`} target='_blank'>
          {item.organizationName}
        </Link>)
      )
    },
    value: ({ organizationName, organizationUuid } = {}) =>
      ({ organizationName, organizationUuid }),
  },
  {
    id: 'apiPlanOrgAccessStatus',
    label: getI18nFormattedMessage("label.access"),
    minWidth: 50,
    format: (item) =>

    (<Switch
      id={`${item.organizationUuid}-access`}
      onChange={(val) => onAccessToggle(val, item.organizationUuid)}
      checked={assignedOrgs?.includes(item.organizationUuid)}
    />

    ),
    value: (item) => (item),

  },
  ];

  const onChangePage = (newPage) => {
    if (page === newPage) { return; }
    setPage(newPage);
    setPayload({ ...payload, page: newPage })
  };
  const onChangePreviousPage = () => { onChangePage(page - 1); };
  const onChangeNextPage = () => { onChangePage(page + 1); };

  const onChangeRowsPerPage = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    setPayload({ ...payload, size: newRowsPerPage })
  };


  const intl = getI18n(useIntl());

  const handleChange = (value, filterType) => {
    switch (filterType) {
      case 'filterByOrgName':
        setFilterByOrgName(value);
        break;
      default:
        break;
    }
  }

  const handleBlur = () => {
    setAppliedFilterByOrgName(filterByOrgName);
    if (appliedFilterByOrgName !== filterByOrgName) {
      setPage(0);
      setPayload({ ...payload, orgName: filterByOrgName });
    }
  }

  useEffect(() => {
    if (apiPlanUuid) {
      dispatch(fetchOrganizationsForApiPlans(apiPlanUuid, {
        page: page,
        size: rowsPerPage,
        orgName: filterByOrgName,
        apiPlanOrgAccessStatus: isOrgsRemoveAccess ? "ASSIGNED" : "NOT_ASSIGNED",
      }))
    }
  }, [payload, apiPlanUuid, isOrgsRemoveAccess])

  const onAssignToggle = () => {
    setAssignedOrgs([
      ...assignedOrgs,
      ...selectedRows.filter(uuid => !assignedOrgs.includes(uuid)),
    ]);
  };

  const onUnAssignToggle = () => {
    setAssignedOrgs(assignedOrgs.filter(organizationUuid =>
      !selectedRows.includes(organizationUuid)));
  };

  const isOrgsTabDirty = useMemo(() => {
    if (apiPlanUuid && isCurrentTab) {
      return compareArrays(assignedOrgs, unAssignedOrgs)
    }
    return false;
  }, [apiPlanUuid, assignedOrgs, unAssignedOrgs, isCurrentTab]);

  useEffect(() => {
    setCurrentTabDirty(isOrgsTabDirty);
  }, [isOrgsTabDirty]);

  const handleAddOrgs = () => {
    setChangeMode(ORGANIZATIONS_ADD_ACCESS);
    setPage(0);
    setFilterByOrgName("");
    setRowsPerPage(GRID_ROWS_PER_PAGE_DEFAULT_OPTION);
    setPayload({
      ...payload,
      apiPlanOrgAccessStatus: "NOT_ASSIGNED",
    })
  }

  const handleCancel = () => {
    const resetApisTabSettings = () => {
      setSelectedRows([]);
      setFilterByOrgName("");
      setPage(0);
      setRowsPerPage(GRID_ROWS_PER_PAGE_DEFAULT_OPTION);
    }
    if (isOrgsRemoveAccess && apiPlanUuid && isCurrentTab && isOrgsTabDirty) {
      resetApisTabSettings();
      setPayload({ ...payload, apiPlanOrgAccessStatus: "ASSIGNED" })
    } else if (isOrgsAddAccess && apiPlanUuid && isCurrentTab && isOrgsTabDirty) {
      resetApisTabSettings();
      setPayload({ ...payload, apiPlanOrgAccessStatus: "NOT_ASSIGNED" })
    } else if (isOrgsAddAccess && !isOrgsTabDirty) {
      setChangeMode(ORGANIZATIONS_REMOVE_ACCESS);
      resetApisTabSettings();
      setPayload({ ...payload, apiPlanOrgAccessStatus: "ASSIGNED" })
    }
  }

  useEffect(() => {
    const rowsData = map(orgsResultsForApiPlans &&
      orgsResultsForApiPlans, (item) => ({ uuid: item.organizationUuid, ...item }));
    setCurrentOrgRows(cloneDeep(rowsData));
  }, [orgsResultsForApiPlans])

  const assignedOrgsPayload = assignedOrgs?.map((organizationUuid) => {
    return {
      uuid: organizationUuid,
    }
  })

  const unAssignedOrgsFiltered = unAssignedOrgs && unAssignedOrgs?.filter(organizationUuid =>
    !assignedOrgs?.includes(organizationUuid)) || [];

  const unAssignedOrgsPayload = unAssignedOrgsFiltered &&
    unAssignedOrgsFiltered?.map(organizationUuid => {
      return {
        uuid: organizationUuid,
      }
    });

  const decideAccessModePayload = useMemo(() => {
    if (isOrgsAddAccess) {
      return assignedOrgsPayload;
    } else if (isOrgsRemoveAccess) {
      return unAssignedOrgsPayload;
    }
  }, [changeMode, assignedOrgsPayload, unAssignedOrgsPayload])

  const handleSaveOrgs = () => {
    setAlertMessages({
      message: "",
      variant: "",
      status: false,
    })
    setPage(0);
    setRowsPerPage(GRID_ROWS_PER_PAGE_DEFAULT_OPTION);
    setFilterByOrgName("");
    setSelectedRows([]);
    dispatch(updateOrganizationsForApiPlans(decideAccessModePayload, apiPlanUuid, changeMode));
  }

  useEffect(() => {
    if (isUpdateOrgsForApiPlansSuccess) {
      setChangeMode(ORGANIZATIONS_REMOVE_ACCESS);
      dispatch({ type: UPDATE_ORGANIZATIONS_FOR_API_PLANS_SUCCESS, payload: "" });
      setPayload({ ...payload, apiPlanOrgAccessStatus: "ASSIGNED" });
    }
  }, [isUpdateOrgsForApiPlansSuccess]);

  const disableAdd = every(selectedRows, uuid => assignedOrgs?.includes(uuid));
  const disableRemove = every(selectedRows, uuid => !assignedOrgs?.includes(uuid));

  return (
    <div>
      {
        orgsResultsForApiPlans &&
        <ListContainer
          listPageId='add-api-plans-organizations-list'
          showListHeader={true}
          isLoading={isLoading}
          noResultsMessage={getI18nFormattedMessage('label.no.results')}
          filterAndSortContent={(
            <div className={classes.filtersContainer}>
              <FilterByName
                id="add-api-plans-organizations-filter-by-name"
                fieldContainerClass={classes.fieldContainer}
                handleChange={(value) => handleChange(value, 'filterByOrgName')}
                name={getI18nFormattedMessage("label.filter")}
                handleBlur={handleBlur}
                placeholder={intl.getI18nMessage("label.organization.name")}
                value={filterByOrgName}
              />
              {
                isOrgsRemoveAccess &&
                <Button
                  id='add-api-plans-add-organization-button'
                  data-apim-test='add-api-plans-add-organization-button'
                  className={classes.addApiButton}
                  variant='contained'
                  color='secondary'
                  onClick={handleAddOrgs}
                  disabled={isOrgsTabDirty}
                >
                  {intl.getI18nMessage("label.organization.list.add.button")}
                </Button>
              }
            </div>
          )}
          columns={getListColumns({ getI18nFormattedMessage })}
          rows={currentOrgRows}
          totalElements={orgsTotalElementsForApiPlans}
          totalPages={orgsTotalPagesForApiPlans}
          onChangeRowsPerPage={onChangeRowsPerPage}
          onChangePage={onChangePage}
          onChangePreviousPage={onChangePreviousPage}
          onChangeNextPage={onChangeNextPage}
          page={page}
          rowsPerPage={rowsPerPage}
          pageClass={classes.listContent}
          pageBodyClass={classes.pageBodyClass}
          pageFilterAndSortClass={classes.pageFilterAndSortClass}
          setSelectedRows={setSelectedRows}
          selectedRows={selectedRows}
          hasBulkActions={false}
          hasPaginationDisabled={isOrgsTabDirty || selectedRows.length > 0}
          bulkActionsContent={
            (<HeaderActionButtons
              {...props}
              id={'add-api-plan-organization-assignment'}
              fieldContainerClass={classes.fieldContainer}
              bulkActionsItemsCount={selectedRows.length}
              classes={classes}
              disableAdd={disableAdd}
              disableRemove={disableRemove}
              onAssign={onAssignToggle}
              onUnassign={onUnAssignToggle}
            />)
          }
        />
      }
      {
        (isOrgsTabDirty || isOrgsAddAccess) && (
          <FormActionButtons
            id='add-api-plans-orgs-tab-action-buttons'
            nextText={intl.getI18nMessage('label.save.button')}
            onNextClick={handleSaveOrgs}
            onCancelClick={handleCancel}
            showCancel
            isContainerFooter
            isDisabled={!isOrgsTabDirty}
          />
        )
      }
    </div>
  )
}

const mapStateToProps = ((state) => ({
  isLoading: getApiPlansLoading(state),
  orgsResultsForApiPlans: getOrganizationsResultsForApiPlans(state),
  orgsTotalElementsForApiPlans: getOrganizationsTotalElementsForApiPlans(state),
  orgsTotalPagesForApiPlans: getOrganizationsTotalPagesForApiPlans(state),
  isUpdateOrgsForApiPlansSuccess: getOrgsUpdateForApiPlans(state),
}))

export default compose(
  connect(mapStateToProps),
)(Organizations);

Organizations.propTypes = {
  apiPlanUuid: PropTypes.string,
  setCurrentTab: PropTypes.func,
  setCurrentTabDirty: PropTypes.func,
  isLoading: PropTypes.bool,
  orgsResultsForApiPlans: PropTypes.array,
  orgsTotalElementsForApiPlans: PropTypes.number,
  orgsTotalPagesForApiPlans: PropTypes.number,
  isUpdateOrgsForApiPlansSuccess: PropTypes.string,
  setAlertMessages: PropTypes.object,
}